<template>
    <div class="page">

        <div class="manage">
            <img class="img-title" src="../../../assets/count/title.png" alt="">

            <div class="manage-location">
                <img src="../../../assets/appointment/img-location.png" alt="">
                <div>官渡区 人民东路1-29栋</div>
            </div>

            <div>
                <div>管家工号：</div>
                <div>工作时间：9:00-18:00</div>
            </div>
        </div>

        <div class="manage-phone" @click="callPhone">
            <img src="../../../assets/appointment/img-phone.png" alt="">
            <strong>联系管家</strong>
        </div>
    </div>
</template>

<script>
    export default {
        name: "manage",

        created() {
            document.title = "我的管家";
        },

        methods: {
            callPhone() {
                window.location.href = "tel:0871-63377881";
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    .manage {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-title {
            margin-top: 80px;
            width: 140px;
            height: 50px;
            margin-bottom: 40px;
        }
        .manage-location {
            justify-content: center;
            min-width: 80%;
            color: $fontColor-9;
            margin-bottom: 40px;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 14px;
            background: #F4F4F4;
            display: flex;
            align-items: center;
            img {
                width: 22px;
                height: 22px;
            }
        }
    }

    .manage-phone {
        box-sizing: border-box;
        padding-bottom: 15px;
        margin: 40px auto;
        width: 90%;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        background: url("../../../assets/button-img.png");
        background-size: 100%;
        height: 66px;
        img {
            width: 22px;
            height: 22px;
        }
    }

</style>
